// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-detail-main {
  width: 90%;
  margin: 2.5rem auto;
  padding: 5rem 0;
}
.user-detail-main h4 {
  margin: 2.5rem 0;
  /* text-align: center; */
  font-weight: bold;
  font-size: 1.25rem;
}

.user-detail-main .detail-section {
  /* box-shadow: var(--boxShadow); */
  background-color: white;
  padding: 1.25rem 1.875rem;
  /* margin: 2.5rem 0; */
  border-radius: 0.75rem;
  display: flex;
  /* justify-content: space-between; */
  min-height: 100%;

  flex-direction: column;
}
.user-detail-main .detail-section .sec-1 {
  text-align: center;
  margin-bottom: 1.25rem;
}

.user-detail-main .detail-section .sec-1 h5 {
  margin-top: 0.625rem;
  font-size: 1.25rem;
  font-weight: bold;
  letter-spacing: 0.063rem;
  text-transform: capitalize;
}
.user-detail-main .detail-section .sec-2 span {
  font-weight: bold;
  letter-spacing: 0.063rem;
}
.user-detail-main .detail-section .sec-2 div {
  margin: 20.313rem 0;
}
.user-detail-main .detail-section .sec-2 p {
  font-size: 0.75rem;
  font-weight: bold;
}
.user-detail-main p span {
  /* font-weight: normal !important; */
}
/* .user-detail-main .order-filter {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 1.25rem 0 1.25rem auto;
} */
.user-detail-main .top-head {
  display: flex;
  align-items: center;
  margin-bottom: 3.125rem;
}
.user-detail-main .top-head h2 {
  margin-bottom: 0;
  margin-left: 0.625rem;
  letter-spacing: 0.063rem;
}
.user-detail-main .ant-tabs-tab {
  font-size: 0.938rem;
  font-weight: 600;
  letter-spacing: 0.063rem;
  font-style: italic;
  text-transform: uppercase;
}
.user-detail-main .history-row {
  margin: 3.125rem 0;
}
.user-detail-main .history-row h5 {
  font-size: 1.125rem;
  text-align: center;
  font-weight: bold;
  letter-spacing: 0.313rem;
  margin-bottom: 0;
}
/* .user-detail-main .history-row .desc {
  font-size: 1rem;
  font-weight: 600;
  font-style: italic;
  display: flex;
  justify-content: center;
} */

@media (max-width: 74.375rem) {
  .user-detail-main .detail-section {
    flex-direction: column;
  }
  .ant-divider-vertical {
    width: 100%;
    border-bottom: 0.125rem solid rgba(138, 27, 106, 0.5);
    margin: 1.25rem 0;
  }
  .user-detail-main .detail-section .sec-1 {
    text-align: center;
    margin-bottom: 1.25rem;
  }
  .user-detail-main .order-filter {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 53.125rem) {
  .user-detail-main .order-filter {
    flex-direction: column;
    align-items: flex-start;
    margin: 1.25rem 0 1.25rem auto;
  }
  .user-detail-main .order-filter p {
    margin-bottom: 0.625rem !important;
    font-size: 0.938rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/userDetail.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,oCAAoC;EACpC,gBAAgB;;EAEhB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA;;;;;;GAMG;AACH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;;;;;;GAMG;;AAEH;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,qDAAqD;IACrD,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,kCAAkC;IAClC,mBAAmB;EACrB;AACF","sourcesContent":[".user-detail-main {\n  width: 90%;\n  margin: 2.5rem auto;\n  padding: 5rem 0;\n}\n.user-detail-main h4 {\n  margin: 2.5rem 0;\n  /* text-align: center; */\n  font-weight: bold;\n  font-size: 1.25rem;\n}\n\n.user-detail-main .detail-section {\n  /* box-shadow: var(--boxShadow); */\n  background-color: white;\n  padding: 1.25rem 1.875rem;\n  /* margin: 2.5rem 0; */\n  border-radius: 0.75rem;\n  display: flex;\n  /* justify-content: space-between; */\n  min-height: 100%;\n\n  flex-direction: column;\n}\n.user-detail-main .detail-section .sec-1 {\n  text-align: center;\n  margin-bottom: 1.25rem;\n}\n\n.user-detail-main .detail-section .sec-1 h5 {\n  margin-top: 0.625rem;\n  font-size: 1.25rem;\n  font-weight: bold;\n  letter-spacing: 0.063rem;\n  text-transform: capitalize;\n}\n.user-detail-main .detail-section .sec-2 span {\n  font-weight: bold;\n  letter-spacing: 0.063rem;\n}\n.user-detail-main .detail-section .sec-2 div {\n  margin: 20.313rem 0;\n}\n.user-detail-main .detail-section .sec-2 p {\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n.user-detail-main p span {\n  /* font-weight: normal !important; */\n}\n/* .user-detail-main .order-filter {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin: 1.25rem 0 1.25rem auto;\n} */\n.user-detail-main .top-head {\n  display: flex;\n  align-items: center;\n  margin-bottom: 3.125rem;\n}\n.user-detail-main .top-head h2 {\n  margin-bottom: 0;\n  margin-left: 0.625rem;\n  letter-spacing: 0.063rem;\n}\n.user-detail-main .ant-tabs-tab {\n  font-size: 0.938rem;\n  font-weight: 600;\n  letter-spacing: 0.063rem;\n  font-style: italic;\n  text-transform: uppercase;\n}\n.user-detail-main .history-row {\n  margin: 3.125rem 0;\n}\n.user-detail-main .history-row h5 {\n  font-size: 1.125rem;\n  text-align: center;\n  font-weight: bold;\n  letter-spacing: 0.313rem;\n  margin-bottom: 0;\n}\n/* .user-detail-main .history-row .desc {\n  font-size: 1rem;\n  font-weight: 600;\n  font-style: italic;\n  display: flex;\n  justify-content: center;\n} */\n\n@media (max-width: 74.375rem) {\n  .user-detail-main .detail-section {\n    flex-direction: column;\n  }\n  .ant-divider-vertical {\n    width: 100%;\n    border-bottom: 0.125rem solid rgba(138, 27, 106, 0.5);\n    margin: 1.25rem 0;\n  }\n  .user-detail-main .detail-section .sec-1 {\n    text-align: center;\n    margin-bottom: 1.25rem;\n  }\n  .user-detail-main .order-filter {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 53.125rem) {\n  .user-detail-main .order-filter {\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 1.25rem 0 1.25rem auto;\n  }\n  .user-detail-main .order-filter p {\n    margin-bottom: 0.625rem !important;\n    font-size: 0.938rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
